import EventResponseInterface, { EventSessionInterface } from '@/webcomponents/f1-season/store/interface/event';
import { EventTrackInterface } from '@/webcomponents/f1-season/store/interface/track';

export default class Event implements EventResponseInterface {
  id = 0;
  foreignId = '';
  eventSequence = '';
  eventName = '';
  eventDate = '';
  eventCountry = '';
  eventFlag = '';
  raceStart = '';
  raceStartLocal = '';
  eventRaceLabs = '';
  eventRaceDistance = 0;
  seasonEventTracks: Array<EventTrackInterface> = [];
  seasonEventSessions: Array<EventSessionInterface> = [];

  constructor (apiData: EventResponseInterface) {
    Object.keys(apiData).forEach((apiDataKey) => {
      this[apiDataKey] = apiData[apiDataKey];
    });
  }
}
